import Axios from 'axios'
import axios from './ajax'
import { getAppVer } from '@/assets/js/utils'
import axiosConfig from '@/config/config'

const CHANNELURL = {
    getConfig: 'atourlife/marketConfig/getMarketConfig',
    getImgCode: 'atourlife/verifyCode/getCodeKey',
    getPhoneMessage: 'atourlife/verifyCode/getVerifyCodeByTypeForH5',
    getTackets: '/atourlife/login/receiveRedPacketByVerifyCode',
    getTacketList: '/atourlife/coupon/getCouponsListByMarketIdNotToken',
    getTokenByTicket: 'atourlife/user/getUserTokenByTicket',
    checkUserInfoBind: 'atourlife/miniapp/login/checkUserInfoBind'
}

export function GetConfig (params) {
    return axios.post(CHANNELURL.getConfig, params)
}

export function GetImgCode (params) {
    return axios.post(CHANNELURL.getImgCode, params)
}

export function GetPhoneMessage (params) {
    return axios.post(CHANNELURL.getPhoneMessage, params.params, {
      headers: params.config
    })
}

export function GetTackets (params) {
    return axios.post(CHANNELURL.getTackets, params.params, params.config)
}

export function GetTacketList (params) {
    return axios.post(CHANNELURL.getTacketList, params)
}

export function GetUserToken (params) {
  const query = `?appVer=${getAppVer()}&channelId=300001&platType=3`
  return Axios.post(axiosConfig.JAVA_SERVER + CHANNELURL.getTokenByTicket + query, params, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function CheckUserInfoBind (params) {
  return axios.get(CHANNELURL.checkUserInfoBind, { params }, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/query/api.js